<template>
  <div
    class="additional-details-highlight"
    v-html="highlightedHtml"
  />
</template>

<script>
import { buildAdditionalDetailsHighlight } from "@/vue/utils/consultationExtractedQuestionsHighlight";

export default {
  name: "AdditionalDetailsHighlightedWithExtractedQuestions",
  props: {
    additionalDetails: {
      type: String,
      default: "",
    },
    extractedQuestions: {
      type: Array,
      default: () => [],
    },
    selectedQuestionId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    highlightedHtml() {
      return buildAdditionalDetailsHighlight({
        additionalDetails: this.additionalDetails,
        extractedQuestions: this.extractedQuestions,
        selectedQuestionId: this.selectedQuestionId,
      });
    },
  },
};
</script>

<style lang="scss">
.additional-details-highlight {
  line-height: 2.0;

  .overlay-editor__underline {
    position: relative;
  }

  .overlay-editor__underline--ai {
    .overlay-editor__underline-text {
      border-bottom: 2px dotted #ccc;
    }

    &--selected {
      .overlay-editor__underline-text {
        background-color: #ffecef;
      }
    }
  }

  .overlay-editor__underline-index {
    position: absolute;
    top: -13px;
    font-size: 9px;
    font-weight: 700;
    color: #1564BD;
    min-width: 25px;
  }
}
</style>
